import { BaseRecipesClient, Recipe } from "@core/types";

class RecipesClient extends BaseRecipesClient {
  async getRecipes(): Promise<Recipe[]> {
    throw new Error("getRecipes not implemented");
  }

  async getRecipeById(recipeId: Recipe["id"]): Promise<Recipe> {
    throw new Error("getRecipeById not implemented");
  }
}

export default RecipesClient;
